/**
 * GDPR Settings Page
 * Page wrapper for GDPR Data Export component
 */

import React from "react";
import { Shield } from "lucide-react";
import { PageBanner } from "../../components/ui/PageBanner";
import { useI18nStore } from "../../stores/i18nStore";
import { GDPRDataExport } from "../../components/gdpr/GDPRDataExport";

export const GDPRSettingsPage: React.FC = () => {
  const { t } = useI18nStore();
  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <PageBanner
        icon={Shield}
        title={t.settings2GdprPageTitle}
        description={t.settings2GdprPageDescription}
      />

      <GDPRDataExport />
    </div>
  );
};
